import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useTitle from "../../../hooks/useTitle";
import { DEBOUNCE_DELAY, initialStateExport, TABS_ANNUAIRE } from "../constant";
import { useQuery } from "react-query";
import { downloadFile, getAnnuaire } from "../../../api/annuaire";
import { debounce } from "../../../utils/global";
import { _formatJsonAnnuaire } from "../utils";
import { roles_access, ROLES_CODE } from "../../../constants/roles";
import useExportRegister from "./useExportRegister";
import { useSearchParams } from "react-router-dom";

const useAnnuaire = () => {
    const { t } = useTranslation("translation");
    useTitle("Annuaire de l'entreprise");
    const [searchParams, setSearchParams] = useSearchParams();

    const {
        path,
        openDownloadDialog,
        checkboxes,
        viewFormer,
        setPath,
        setOpenDownloadDialog,
        setCheckboxes,
        setViewFormer,
        onConfirmExportRegister,
    } = useExportRegister();

    // * annuaire states
    const [TabView, setTabView] = useState(TABS_ANNUAIRE.ANNUAIRE);
    const [query, setQuery] = useState("");

    useEffect(() => {
        setQuery(searchParams.get("q") || "");
    }, []);

    /**
     * get annuaire data from API.
     */
    const { data: annuaire, isLoading } = useQuery(
        ["getAnnuaire", searchParams.toString()],
        () => {
            return getAnnuaire(searchParams.toString());
        },
        {
            enabled: TabView === TABS_ANNUAIRE.ANNUAIRE,
        }
    );

    const { isLoading: isDownloadingFile, isFetching: isFetchingDownload } =
        useQuery(
            ["ANNUAIRE::download_file", path],
            () => {
                return downloadFile(path);
            },
            {
                enabled: path !== "",
                onSuccess: () => {
                    setOpenDownloadDialog(false);
                    setCheckboxes(initialStateExport);
                    setPath("");
                },
            }
        );
    // on change search input
    const onChange = debounce((value) => {
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("q");
        if (value ?? "".trim()) {
            setQuery(value);
            newSearchParams.append("q", value);
        } else {
            setQuery("");
        }
        setSearchParams(newSearchParams);
    }, DEBOUNCE_DELAY);

    /**
     * format JSON for displaying items
     */
    const panels = _formatJsonAnnuaire(annuaire);

    const isHR = roles_access({
        usersPrivileges: [ROLES_CODE.hr],
    });
    const isManager = roles_access({
        usersPrivileges: [ROLES_CODE.manager],
    });

    return {
        t,
        export: {
            openDownloadDialog,
            checkboxes,
            viewFormer,
            isDownloadingFile: isDownloadingFile || isFetchingDownload,
            setOpenDownloadDialog,
            setCheckboxes,
            setViewFormer,
            onConfirmExportRegister,
        },
        annuaire: {
            annuaire,
            panels,
            query,
            isLoading,
            TabView,
            setTabView,
            onChange,
        },
        permissions: {
            can_export_personals_register: isHR && isManager,
        },
    };
};

export default useAnnuaire;
